import { invert } from 'lodash';
import ALERT_CONSTS from 'cyberint-alert-consts';
import * as FEATURES from './features';

const COMPANY_EMPLOYEE_CORPORATE_CREDENTIALS_EXPOSED = 'company_employee_corporate_credentials_exposed';
const COMPANY_EMPLOYEE_THIRD_PARTY_CREDENTIALS_EXPOSED = 'company_employee_third_party_credentials_exposed';
const COMPANY_EMPLOYEE_CREDENTIALS_OFFERED_FOR_SALE = 'company_employee_credentials_offered_for_sale';
const COMPANY_CUSTOMER_CREDENTIALS_OFFERED_FOR_SALE = 'company_customer_credentials_offered_for_sale';
const SOCIAL_MEDIA_ACCOUNT_IMPERSONATING_COMPANY_EXECUTIVE = 'social_media_account_impersonating_company_executive';
const SOCIAL_MEDIA_ACCOUNT_IMPERSONATING_COMPANY = 'social_media_account_impersonating_company';
const MOBILE_APP_IMPERSONATING_COMPANY = 'mobile_app_impersonating_company';
const COMPANY_CUSTOMER_PAYMENT_CARDS_OFFERED_FOR_SALE = 'company_customer_payment_cards_offered_for_sale';
const COMPANY_CUSTOMER_CREDENTIALS_EXPOSED = 'company_customer_credentials_exposed';
const CREDENTIAL_STUFFING_TOOL_TARGETING_COMPANY = 'credential_stuffing_tool_targeting_company';
const BRUTE_FORCE_TOOL_TARGETING_COMPANY = 'brute_force_tool_targeting_company';
const EXPLOITABLE_PORT_ON_COMPANY_SERVER_DETECTED = 'exploitable_port_on_company_server_detected';
const COMPANY_SUBDOMAIN_VULNERABLE_TO_HIJACKING = 'company_subdomain_vulnerable_to_hijacking';
const ACTIVE_PHISHING_WEBSITE_TARGETING_COMPANY = 'active_phishing_website_targeting_company';
const PHISHING_KIT_TARGETING_COMPANY = 'phishing_kit_targeting_company';
const BRAND_ABUSING_WEBSITE_IMPERSONATING_COMPANY = 'brand_abusing_website_impersonating_company';
const LOOK_ALIKE_DOMAIN_POTENTIALLY_TARGETING_COMPANY = 'lookalike_domain_potentially_targeting_company';
const LOOK_ALIKE_SUBDOMAIN_POTENTIALLY_TARGETING_COMPANY = 'lookalike_subdomain_potentially_targeting_company';
const MALICIOUS_FILE_EMPLOYEE_MACHINE_INFECTED_BY_MALWARE = 'malicious_file_employee_machine_infected_by_malware';
const MALICIOUS_FILE_TARGETING_COMPANY_EMPLOYEE = 'malicious_file_targeting_company_employees';
const COMPANY_INTERNAL_EMAIL_CORRESPONDENCE_EXPOSED = 'company_internal_email_correspondence_exposed';
const COMPANY_CUSTOMER_PAYMENT_CARDS_EXPOSED = 'company_customer_payment_cards_exposed';
const EXPOSED_COMPANY_CLOUD_STORAGE_BUCKET_DETECTED = 'exposed_company_cloud_storage_bucket_detected';
const BREACHED_DATA_POTENTIALLY_RELATED_TO_COMPANY = 'breached_data_potentially_related_to_company';
const COMPANY_CUSTOMER_CREDS_OFFERED_FOR_SALE = 'company_customer_credentials_offered_for_sale';
const COMPANY_EMPLOYEE_CREDS_OFFERED_FOR_SALE = 'company_employee_credentials_offered_for_sale';
const CREDENTIAL_STUFFING_TARGETING_COMPANY = 'credential_stuffing_tool_targeting_company';
const RANSOMWARE_ATTACK_TARGETING_COMPANY = 'ransomware_attack_targeting_company';
const DATA_SCRAPING_TOOL_FOR_COMPANY_APPLICATION = 'data_scraping_tool_for_company_application';
const VULNERABILITY_SCANNER_TARGETING_COMPANY = 'vulnerability_scanner_targeting_company';
const FRAUDULENT_REFUND_SERVICES_TARGETING_COMPANY = 'fraudulent_refund_services_targeting_company';
const FRAUDULENT_REFUND_TUTORIAL_TARGETING_COMPANY = 'fraudulent_refund_tutorial_targeting_company';
const COMPANY_SOURCE_CODE_EXPOSED = 'company_source_code_exposed';
const COMPANY_EMPLOYEE_PRIVATE_ACCESS_TOKEN_EXPOSED = 'company_employee_private_access_token_exposed';
const EXPOSED_COMPANY_WEB_INTERFACE = 'exposed_company_web_interface';
const MISSING_COMPANY_DOMAIN_DMARC_RECORDS_DETECTED = 'missing_company_domain_dmarc_records_detected';
const MISCONFIGURED_COMPANY_DOMAIN_DMARC_RECORDS_DETECTED = 'misconfigured_company_domain_dmarc_records_detected';
const MISSING_COMPANY_DOMAIN_SPF_RECORDS_DETECTED = 'missing_company_domain_spf_records_detected';
const MISCONFIGURED_COMPANY_DOMAIN_SPF_RECORDS_DETECTED = 'misconfigured_company_domain_spf_records_detected';
const MISSING_COMPANY_DOMAIN_CAA_RECORDS_DETECTED = 'missing_company_domain_caa_records_detected';
const MISCONFIGURED_COMPANY_DOMAIN_CAA_RECORDS_DETECTED = 'misconfigured_company_domain_caa_records_detected';
const COMPANY_MAIL_SERVER_BLACKLISTED = 'company_mail_server_blacklisted';
const MISSING_CAA = 'missing_company_domain_caa_records_detected';
const COMPANY_MAIL_SERVER_BLOCKLISTED = 'company_mail_server_blacklisted';
const MOBILE_APPLICATION_IMPERSONATING_COMPANY = 'mobile_app_impersonating_company';
const MOBILE_APP_DISTRIBUTED_UNOFFICIALLY = 'mobile_app_distributed_unofficially';
const COMPANY_CONFIDENTIAL_FILE_EXPOSED = 'company_confidential_file_exposed';
const COMPANY_CUSTOMER_CREDENTIALS_AND_PII_EXPOSED = 'company_customer_credentials_and_pii_exposed';
const COMPANY_CUSTOMER_PAYMENT_CARDS_AND_PII_EXPOSED = 'company_customer_payment_cards_and_pii_exposed';
const FAKE_JOB_POSTING_IMPERSONATING_COMPANY = 'fake_job_posting_impersonating_company';
const FAKE_JOB_POSTING_IMPERSONATING_COMPANY_EMPLOYEE = 'fake_job_posting_impersonating_company_employee';
const THIRD_PARTY_VENDOR_BREACHED = 'third_party_vendor_breached';
const RANSOMWARE_ATTACK_TARGETING_THIRD_PARTY_VENDOR = 'ransomware_attack_targeting_third_party_vendor';
const VULNERABLE_TECHNOLOGY_DETECTED_ON_EXPOSED_COMPANY_ASSET =
  'vulnerable_technology_detected_on_exposed_company_asset';
const HIGHLY_RANKED_CVE_FOUND_ON_A_TECHNOLOGY = 'highly_ranked_cve_found_on_a_technology';
const EXPOSED_DIRECTORY_LISTING = 'exposed_directory_listing';
const FRAUDULENT_ACCOUNT_TEMP_PHONE = 'fraudulent_account_temp_phone';
const POTENTIAL_DDOS_ATTACK = 'potential_ddos_attack';

const VULNERABLE_TECHNOLOGY_DETECTED = 'vulnerable_technology_detected_on_manually_added_technology';
const EXPLOITABLE_VULNERABILITY_FOUND_ON_COMPANY_ASSET = 'exploitable_vulnerability_found_on_company_asset';
const SSL_TLS_CERTIFICATE_EXPIRY = 'ssl_tls_certificate_expiry';

// SSL/TLS
export const OUTDATED_VERSION_SSL_TLS_SUPPORTED = 'tls_outdated_version_ssl_tls_supported';
export const TLS_NO_FORWARD_SECRECY = 'tls_no_forward_secrecy';
export const TLS_LATEST_VERSION_NOT_SUPPORTED = 'tls_latest_version_not_supported';
export const TLS_SERVER_HAS_KNOWN_VULNERABILITY = 'tls_server_has_known_vulnerability';
export const TLS_INSECURE_CIPHER_SUITES = 'tls_insecure_cipher_suites';
export const TLS_WEAK_CIPHER_SUITES = 'tls_weak_cipher_suites';
export const TLS_SERVER_ACCEPTS_INSECURE_RENEGOTIATION = 'tls_server_accepts_insecure_renegotiation';

const EXPLOIT_FOUND_ON_COMPANY_ASSET = 'exploit_found_on_company_asset';
const SM_ACCOUNT_IMPERSONATING_COMPANY = 'social_media_account_impersonating_company';
const SM_ACCOUNT_IMPERSONATING_COMPANY_EXECUTIVE = 'social_media_account_impersonating_company_executive';

const WEB_APP_SECURITY_MISSING_HSTS_HEADER_DETECTED = 'web_app_security_missing_hsts_header_detected';
const WEB_APP_SECURITY_MISCONFIGURED_HSTS_HEADER_DETECTED = 'web_app_security_misconfigured_hsts_header_detected';
const WEB_APP_SECURITY_MISSING_X_FRAME_OPTIONS_HEADER_DETECTED =
  'web_app_security_missing_x_frame_options_header_detected';
const WEB_APP_SECURITY_MISCONFIGURED_X_FRAME_OPTIONS_HEADER_DETECTED =
  'web_app_security_misconfigured_x_frame_options_header_detected';
const WEB_APP_SECURITY_MISSING_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED =
  'web_app_security_missing_x_content_type_options_header_detected';
const WEB_APP_SECURITY_MISCONFIGURED_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED =
  'web_app_security_misconfigured_x_content_type_options_header_detected';
const WEB_APP_SECURITY_MISSING_CONTENT_SECURITY_POLICY_HEADER_DETECTED =
  'web_app_security_missing_content_security_policy_header_detected';
const WEB_APP_SECURITY_MISSING_REFERRER_POLICY_HEADER_DETECTED =
  'web_app_security_missing_referrer_policy_header_detected';
const WEB_APP_SECURITY_MISSING_X_PERMITTED_CROSS_DOMAIN_POLICIES_HEADER_DETECTED =
  'web_app_security_missing_x_permitted_cross_domain_policies_header_detected';

export const ASM_ALERTS = {
  EXPLOITABLE_PORT_ON_COMPANY_SERVER_DETECTED: 'exploitable_port_on_company_server_detected',
  COMPANY_SUBDOMAIN_VULNERABLE_TO_HIJACKING: 'company_subdomain_vulnerable_to_hijacking',
  EXPOSED_COMPANY_WEB_INTERFACE: 'exposed_company_web_interface',
  EXPOSED_COMPANY_CLOUD_STORAGE_BUCKET_DETECTED: 'exposed_company_cloud_storage_bucket_detected',
  MISSING_COMPANY_DOMAIN_DMARC_RECORDS_DETECTED: 'missing_company_domain_dmarc_records_detected',
  COMPANY_MAIL_SERVER_BLACKLISTED: 'company_mail_server_blacklisted',
  COMPANY_EMPLOYEE_CORPORATE_CREDENTIALS_EXPOSED: 'company_employee_corporate_credentials_exposed',
  COMPANY_EMPLOYEE_THIRD_PARTY_CREDENTIALS_EXPOSED: 'company_employee_third_party_credentials_exposed',
  COMPANY_CUSTOMER_PAYMENT_CARDS_EXPOSED: 'company_customer_payment_cards_exposed',
  MISSING_COMPANY_DOMAIN_SPF_RECORDS_DETECTED: 'missing_company_domain_spf_records_detected',
  MISSING_COMPANY_DOMAIN_CAA_RECORDS_DETECTED: 'missing_company_domain_caa_records_detected',
  WEB_APPLICATION_VULNERABILITY_EXPLOIT_PUBLISHED: 'web_application_vulnerability_exploit_published',
  VULNERABLE_TECHNOLOGY_DETECTED_ON_EXPOSED_COMPANY_ASSET: 'vulnerable_technology_detected_on_exposed_company_asset',
  HIGHLY_RANKED_CVE_FOUND_ON_A_TECHNOLOGY: 'highly_ranked_cve_found_on_a_technology'
};

export const CONFIGURATIONS = {
  COMPANY_EMPLOYEE_CORPORATE_CREDENTIALS_EXPOSED,
  COMPANY_EMPLOYEE_THIRD_PARTY_CREDENTIALS_EXPOSED,
  COMPANY_CUSTOMER_PAYMENT_CARDS_OFFERED_FOR_SALE,
  COMPANY_CUSTOMER_CREDENTIALS_EXPOSED,
  COMPANY_EMPLOYEE_CREDENTIALS_OFFERED_FOR_SALE,
  COMPANY_CUSTOMER_CREDENTIALS_OFFERED_FOR_SALE,
  SOCIAL_MEDIA_ACCOUNT_IMPERSONATING_COMPANY_EXECUTIVE,
  SOCIAL_MEDIA_ACCOUNT_IMPERSONATING_COMPANY,
  MOBILE_APP_IMPERSONATING_COMPANY,
  EXPLOITABLE_PORT_ON_COMPANY_SERVER_DETECTED,
  CREDENTIAL_STUFFING_TOOL_TARGETING_COMPANY,
  BRUTE_FORCE_TOOL_TARGETING_COMPANY,
  COMPANY_SUBDOMAIN_VULNERABLE_TO_HIJACKING,
  ACTIVE_PHISHING_WEBSITE_TARGETING_COMPANY,
  PHISHING_KIT_TARGETING_COMPANY,
  BRAND_ABUSING_WEBSITE_IMPERSONATING_COMPANY,
  LOOK_ALIKE_DOMAIN_POTENTIALLY_TARGETING_COMPANY,
  LOOK_ALIKE_SUBDOMAIN_POTENTIALLY_TARGETING_COMPANY,
  MALICIOUS_FILE_EMPLOYEE_MACHINE_INFECTED_BY_MALWARE,
  MALICIOUS_FILE_TARGETING_COMPANY_EMPLOYEE,
  COMPANY_INTERNAL_EMAIL_CORRESPONDENCE_EXPOSED,
  COMPANY_CUSTOMER_PAYMENT_CARDS_EXPOSED,
  EXPOSED_COMPANY_CLOUD_STORAGE_BUCKET_DETECTED,
  BREACHED_DATA_POTENTIALLY_RELATED_TO_COMPANY,
  COMPANY_CUSTOMER_CREDS_OFFERED_FOR_SALE,
  COMPANY_EMPLOYEE_CREDS_OFFERED_FOR_SALE,
  CREDENTIAL_STUFFING_TARGETING_COMPANY,
  RANSOMWARE_ATTACK_TARGETING_COMPANY,
  DATA_SCRAPING_TOOL_FOR_COMPANY_APPLICATION,
  VULNERABILITY_SCANNER_TARGETING_COMPANY,
  FRAUDULENT_REFUND_SERVICES_TARGETING_COMPANY,
  FRAUDULENT_REFUND_TUTORIAL_TARGETING_COMPANY,
  COMPANY_SOURCE_CODE_EXPOSED,
  COMPANY_EMPLOYEE_PRIVATE_ACCESS_TOKEN_EXPOSED,
  EXPOSED_COMPANY_WEB_INTERFACE,
  MISSING_COMPANY_DOMAIN_DMARC_RECORDS_DETECTED,
  MISCONFIGURED_COMPANY_DOMAIN_DMARC_RECORDS_DETECTED,
  MISSING_COMPANY_DOMAIN_SPF_RECORDS_DETECTED,
  MISCONFIGURED_COMPANY_DOMAIN_SPF_RECORDS_DETECTED,
  MISSING_COMPANY_DOMAIN_CAA_RECORDS_DETECTED,
  MISCONFIGURED_COMPANY_DOMAIN_CAA_RECORDS_DETECTED,
  COMPANY_MAIL_SERVER_BLACKLISTED,
  MISSING_CAA,
  COMPANY_MAIL_SERVER_BLOCKLISTED,
  MOBILE_APPLICATION_IMPERSONATING_COMPANY,
  MOBILE_APP_DISTRIBUTED_UNOFFICIALLY,
  COMPANY_CONFIDENTIAL_FILE_EXPOSED,
  COMPANY_CUSTOMER_CREDENTIALS_AND_PII_EXPOSED,
  COMPANY_CUSTOMER_PAYMENT_CARDS_AND_PII_EXPOSED,
  FAKE_JOB_POSTING_IMPERSONATING_COMPANY,
  FAKE_JOB_POSTING_IMPERSONATING_COMPANY_EMPLOYEE,
  THIRD_PARTY_VENDOR_BREACHED,
  RANSOMWARE_ATTACK_TARGETING_THIRD_PARTY_VENDOR,
  VULNERABLE_TECHNOLOGY_DETECTED_ON_EXPOSED_COMPANY_ASSET,
  HIGHLY_RANKED_CVE_FOUND_ON_A_TECHNOLOGY,
  EXPOSED_DIRECTORY_LISTING,
  FRAUDULENT_ACCOUNT_TEMP_PHONE,
  POTENTIAL_DDOS_ATTACK,
  VULNERABLE_TECHNOLOGY_DETECTED,
  EXPLOITABLE_VULNERABILITY_FOUND_ON_COMPANY_ASSET,
  SSL_TLS_CERTIFICATE_EXPIRY,
  EXPLOIT_FOUND_ON_COMPANY_ASSET,
  SM_ACCOUNT_IMPERSONATING_COMPANY,
  SM_ACCOUNT_IMPERSONATING_COMPANY_EXECUTIVE,
  OUTDATED_VERSION_SSL_TLS_SUPPORTED,
  TLS_NO_FORWARD_SECRECY,
  TLS_LATEST_VERSION_NOT_SUPPORTED,
  TLS_SERVER_HAS_KNOWN_VULNERABILITY,
  TLS_INSECURE_CIPHER_SUITES,
  TLS_WEAK_CIPHER_SUITES,
  TLS_SERVER_ACCEPTS_INSECURE_RENEGOTIATION,
  WEB_APP_SECURITY_MISSING_HSTS_HEADER_DETECTED,
  WEB_APP_SECURITY_MISCONFIGURED_HSTS_HEADER_DETECTED,
  WEB_APP_SECURITY_MISSING_X_FRAME_OPTIONS_HEADER_DETECTED,
  WEB_APP_SECURITY_MISCONFIGURED_X_FRAME_OPTIONS_HEADER_DETECTED,
  WEB_APP_SECURITY_MISSING_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED,
  WEB_APP_SECURITY_MISCONFIGURED_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED,
  WEB_APP_SECURITY_MISSING_CONTENT_SECURITY_POLICY_HEADER_DETECTED,
  WEB_APP_SECURITY_MISSING_REFERRER_POLICY_HEADER_DETECTED,
  WEB_APP_SECURITY_MISSING_X_PERMITTED_CROSS_DOMAIN_POLICIES_HEADER_DETECTED
};

const SUBTYPE_TO_FEATURE_MAP = {
  [COMPANY_EMPLOYEE_CORPORATE_CREDENTIALS_EXPOSED]: FEATURES.AUTOMATIC_ALERTS_CORP_CREDENTIALS_EXPOSED,
  [COMPANY_EMPLOYEE_THIRD_PARTY_CREDENTIALS_EXPOSED]: FEATURES.AUTOMATIC_ALERTS_3RD_PARTY_CREDENTIALS_EXPOSED,
  [COMPANY_CUSTOMER_CREDENTIALS_EXPOSED]: FEATURES.AUTOMATIC_ALERTS_CUSTOMER_CREDENTIALS,
  [EXPLOITABLE_PORT_ON_COMPANY_SERVER_DETECTED]: FEATURES.AUTOMATIC_ALERTS_EXPLOITABLE_PORT,
  [COMPANY_SUBDOMAIN_VULNERABLE_TO_HIJACKING]: FEATURES.AUTOMATIC_ALERTS_HIJACKABLE_SUBDOMAIN,
  [ACTIVE_PHISHING_WEBSITE_TARGETING_COMPANY]: FEATURES.AUTOMATIC_ALERTS_PHISHING_WEBSITE,
  [LOOK_ALIKE_DOMAIN_POTENTIALLY_TARGETING_COMPANY]: FEATURES.AUTOMATIC_ALERTS_LOOKALIKE_DOMAIN,
  [MALICIOUS_FILE_EMPLOYEE_MACHINE_INFECTED_BY_MALWARE]: FEATURES.AUTOMATIC_ALERTS_INFECTED_MACHINE,
  [MALICIOUS_FILE_TARGETING_COMPANY_EMPLOYEE]: FEATURES.AUTOMATIC_ALERTS_MALICIOUS_FILE_TARGETING_EMPLOYEES,
  [COMPANY_INTERNAL_EMAIL_CORRESPONDENCE_EXPOSED]: FEATURES.AUTOMATIC_ALERTS_INTERNAL_EMAIL_CORRESPONDENCE,
  [COMPANY_CUSTOMER_PAYMENT_CARDS_EXPOSED]: FEATURES.AUTOMATIC_PAYMENT_CARDS_EXPOSED,
  [EXPOSED_COMPANY_CLOUD_STORAGE_BUCKET_DETECTED]: FEATURES.AUTOMATIC_ALERTS_EXPOSED_CLOUD_STORAGE,
  [COMPANY_EMPLOYEE_PRIVATE_ACCESS_TOKEN_EXPOSED]: FEATURES.AUTOMATIC_ALERTS_EXPOSED_ACCESS_TOKEN,
  [EXPOSED_COMPANY_WEB_INTERFACE]: FEATURES.AUTOMATIC_ALERTS_EXPOSED_WEB_INTERFACE,
  [MISSING_COMPANY_DOMAIN_SPF_RECORDS_DETECTED]: FEATURES.AUTOMATIC_ALERTS_MISSING_COMPANY_DOMAIN_SPF_RECORDS,
  [MISSING_COMPANY_DOMAIN_DMARC_RECORDS_DETECTED]: FEATURES.AUTOMATIC_ALERTS_MISSING_COMPANY_DOMAIN_DMARC_RECORDS,
  [MISSING_CAA]: FEATURES.AUTOMATIC_ALERTS_MISSING_COMPANY_DOMAIN_CAA_RECORDS,
  [COMPANY_MAIL_SERVER_BLOCKLISTED]: FEATURES.AUTOMATIC_ALERTS_COMPANY_MAIL_SERVER_BLOCKLISTED,
  [MOBILE_APPLICATION_IMPERSONATING_COMPANY]: FEATURES.AUTOMATIC_ALERTS_MOBILE_APP_IMPERSONATING_COMPANY,
  [MOBILE_APP_DISTRIBUTED_UNOFFICIALLY]: FEATURES.AUTOMATIC_ALERTS_MOBILE_APP_DISTRIBUTED_UNOFFICIALLY,
  [COMPANY_CONFIDENTIAL_FILE_EXPOSED]: FEATURES.AUTOMATIC_ALERTS_COMPANY_CONFIDENTIAL_FILE_EXPOSED,
  [BREACHED_DATA_POTENTIALLY_RELATED_TO_COMPANY]:
    FEATURES.AUTOMATIC_ALERTS_BREACHED_DATA_POTENTIALLY_RELATED_TO_COMPANY,
  [COMPANY_SOURCE_CODE_EXPOSED]: FEATURES.AUTOMATIC_ALERTS_COMPANY_SOURCE_CODE_EXPOSED,
  [COMPANY_CUSTOMER_CREDS_OFFERED_FOR_SALE]: FEATURES.AUTOMATIC_ALERTS_CUSTOMER_CREDENTIALS,
  [COMPANY_EMPLOYEE_CREDS_OFFERED_FOR_SALE]: FEATURES.AUTOMATIC_ALERTS_EMPLOYEE_CREDENTIALS_OFFERED_FOR_SALE,
  [CREDENTIAL_STUFFING_TARGETING_COMPANY]: FEATURES.AUTOMATIC_ALERTS_CREDENTIAL_STUFFING_TARGETING_COMPANY,
  [VULNERABLE_TECHNOLOGY_DETECTED_ON_EXPOSED_COMPANY_ASSET]: FEATURES.AUTOMATIC_ALERTS_VULNERABLE_TECHNOLOGY_ON_ASSET,
  [EXPLOITABLE_VULNERABILITY_FOUND_ON_COMPANY_ASSET]:
    FEATURES.AUTOMATIC_ALERT_EXPLOITABLE_VULNERABILITY_FOUND_ON_COMPANY_ASSET,
  [SSL_TLS_CERTIFICATE_EXPIRY]: FEATURES.AUTOMATIC_ALERTS_SSL_CERTIFICATE_EXPIRE,
  [EXPLOIT_FOUND_ON_COMPANY_ASSET]: FEATURES.AUTOMATIC_ALERT_EXPLOIT_FOUND_ON_COMPANY_ASSET,
  [SM_ACCOUNT_IMPERSONATING_COMPANY]: FEATURES.AUTOMATIC_SM_ACCOUNT_IMPERSONATING_COMPANY,
  [SM_ACCOUNT_IMPERSONATING_COMPANY_EXECUTIVE]: FEATURES.AUTOMATIC_SM_ACCOUNT_IMPERSONATING_COMPANY_EXECUTIVE,
  [VULNERABLE_TECHNOLOGY_DETECTED]: FEATURES.AUTOMATIC_ALERTS_VULNERABLE_TECHNOLOGY_ON_MANUALLY_ADDED_TECHNOLOGY,
  [OUTDATED_VERSION_SSL_TLS_SUPPORTED]: FEATURES.AUTOMATIC_ALERTS_TLS_OUTDATED_VERSION_SSL_TLS_SUPPORTED,
  [TLS_NO_FORWARD_SECRECY]: FEATURES.AUTOMATIC_ALERTS_TLS_NO_FORWARD_SECRECY,
  [TLS_LATEST_VERSION_NOT_SUPPORTED]: FEATURES.AUTOMATIC_ALERTS_TLS_LATEST_VERSION_NOT_SUPPORTED,
  [TLS_SERVER_HAS_KNOWN_VULNERABILITY]: FEATURES.AUTOMATIC_ALERTS_TLS_SERVER_HAS_KNOWN_VULNERABILITY,
  [TLS_INSECURE_CIPHER_SUITES]: FEATURES.AUTOMATIC_ALERTS_TLS_INSECURE_CIPHER_SUITES,
  [TLS_WEAK_CIPHER_SUITES]: FEATURES.AUTOMATIC_ALERTS_TLS_WEAK_CIPHER_SUITES,
  [TLS_SERVER_ACCEPTS_INSECURE_RENEGOTIATION]: FEATURES.AUTOMATIC_ALERTS_TLS_SERVER_ACCEPTS_INSECURE_RENEGOTIATION,
  [WEB_APP_SECURITY_MISSING_HSTS_HEADER_DETECTED]:
    FEATURES.AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_HSTS_HEADER_DETECTED,
  [WEB_APP_SECURITY_MISCONFIGURED_HSTS_HEADER_DETECTED]:
    FEATURES.AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISCONFIGURED_HSTS_HEADER_DETECTED,
  [WEB_APP_SECURITY_MISSING_X_FRAME_OPTIONS_HEADER_DETECTED]:
    FEATURES.AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_X_FRAME_OPTIONS_HEADER_DETECTED,
  [WEB_APP_SECURITY_MISCONFIGURED_X_FRAME_OPTIONS_HEADER_DETECTED]:
    FEATURES.AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISCONFIGURED_X_FRAME_OPTIONS_HEADER_DETECTED,
  [WEB_APP_SECURITY_MISSING_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED]:
    FEATURES.AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED,
  [WEB_APP_SECURITY_MISCONFIGURED_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED]:
    FEATURES.AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISCONFIGURED_X_CONTENT_TYPE_OPTIONS_HEADER_DETECTED,
  [WEB_APP_SECURITY_MISSING_CONTENT_SECURITY_POLICY_HEADER_DETECTED]:
    FEATURES.AUTOMATIC_ALERTS_WEB_APP_SECURITY_MISSING_CONTENT_SECURITY_POLICY_HEADER_DETECTED,
  [PHISHING_KIT_TARGETING_COMPANY]: FEATURES.AUTOMATIC_ALERTS_PHISHING_KIT_TARGETING_COMPANY,
  [COMPANY_CUSTOMER_PAYMENT_CARDS_OFFERED_FOR_SALE]: FEATURES.AUTOMATIC_ALERTS_CUSTOMER_PAYMENT_CARDS_OFFERED_FOR_SALE,
  [FRAUDULENT_REFUND_SERVICES_TARGETING_COMPANY]:
    FEATURES.AUTOMATIC_ALERTS_FRAUDULENT_REFUND_SERVICES_TARGETING_COMPANY,
  [RANSOMWARE_ATTACK_TARGETING_COMPANY]: FEATURES.AUTOMATIC_ALERTS_RANSOMWARE_ATTACK_TARGETING_COMPANY,
  [DATA_SCRAPING_TOOL_FOR_COMPANY_APPLICATION]: FEATURES.AUTOMATIC_ALERTS_DATA_SCRAPING_TOOL_FOR_COMPANY_APPLICATION,
  [FRAUDULENT_REFUND_TUTORIAL_TARGETING_COMPANY]: FEATURES.AUTOMATIC_ALERTS_FRAUDULENT_REFUND_TUTORIAL_TARGETING_COMPANY
};

export const SUBTYPE_TO_FEATURE = ALERT_CONSTS?.FEATURE_TO_ALERT_SUBTYPE
  ? invert(ALERT_CONSTS.FEATURE_TO_ALERT_SUBTYPE)
  : SUBTYPE_TO_FEATURE_MAP;

export const CATALOG = ALERT_CONSTS.CATALOG;

const OPTIMIZED = 'optimized';
const LIGHT = 'light';
const STRICT = 'strict';
export const POLICIES = { OPTIMIZED, LIGHT, STRICT };

/** Types - add as you need */
const USER_DEFINED_SAVED_QUERY = 'user_defined_saved_query';
const OTHER = 'other';
const IMPERSONATION = 'impersonation';

export const ALERT_TYPES = {
  USER_DEFINED_SAVED_QUERY,
  OTHER,
  IMPERSONATION
};

const ATTACKWARE = 'attackware';
const BRAND = 'brand';
const DATA = 'data';
const FRAUD = 'fraud';
const PHISHING = 'phishing';
const SUPPLY_CHAIN = 'supply_chain';
const VULNERABILITIES = 'vulnerabilities';
export const ALERT_CATEGORIES = {
  ATTACKWARE,
  BRAND,
  DATA,
  FRAUD,
  PHISHING,
  SUPPLY_CHAIN,
  VULNERABILITIES
};
